import { CHANNEL, channelService } from "../../../Channel/channelConfig";
import { errorText, isOk } from "../../../Channel/channelUtils";
import { AdminApiError } from "../../hooks/useAdminList";

export { channelService };

// Link publico da vitrine (o que a ScontiPoste publica)
export const showcaseUrl = () => `${window.location.origin}${CHANNEL.path}`;

export const showcaseUtmUrl = () =>
  `${showcaseUrl()}?utm_source=scontiposte&utm_medium=referral&utm_campaign=scontiposte`;

// Chama o servico e devolve o result; senao lanca com o texto do erro (codigos do canal + mensagens gerais)
export const callChannel = async (request) => {
  const res = await request();
  if (!isOk(res)) {
    // AdminApiError: o useAdminList mostra o codigo; message traz o texto do canal para os toasts desta tela
    const error = new AdminApiError(res?.messageCode ?? 500000);
    error.message = errorText(res);
    throw error;
  }
  return res.result;
};

export const toApiDate = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const defaultPeriod = () => {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 29);
  return { from: toApiDate(from), to: toApiDate(to) };
};

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "—");

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString() : "—");

// CSV com ; (abre direto no Excel em it/pt/es) e BOM para os acentos
export const downloadCsv = (filename, header, rows) => {
  const escape = (value) => {
    const text = value === null || value === undefined ? "" : String(value);
    return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const content = [header, ...rows].map((row) => row.map(escape).join(";")).join("\n");
  const blob = new Blob([`﻿${content}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
